import { Box, Divider, styled } from '@mui/material';

export const BoxContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%',
});

export const RowNoData = styled('div')({
  fontSize: 20,
  margin: '40px 0',
});

export const AppDivider = styled(Divider)({
  margin: '15px 0',
});
